import React from 'react';
import { Box, CardMedia, Container } from '@mui/material';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
// import CardMedia from '@mui/material/CardMedia';
import logo from './Images/Logo.png'
import dropDownLogo from './Images/DropDown.png';
import poster from './Images/Poster.png';
import Twitter from './Images/Twitter.png';
import Instagram from './Images/Instagram.png';
import Facebook from './Images/facebook.png';
import card_img_1 from './Images/Card_img_1.png';
import card_img_2 from './Images/Card_img_2.png';
import card_img_3 from './Images/Card_img_3.png';
import card_img_4 from './Images/Card_img_4.png';
import footer_twitter_icon from './Images/Footer_twitter.png'
import footer_insta_icon from './Images/Footer_insta.png'
import footer_facebook_icon from './Images/footer_facebook.png';
import appstore from './Images/appStore.png';
import googleStore from './Images/googleStore.png';
import line from './Images/line.png';
import menuIcon from './Images/menu.png';
import { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import './style.css';
import Navbar from '../Header/Navbar'
import Footer from '../Footer/Footer';
import DiscountFooterSection from '../DiscountFooterSection/DiscountFooterSection';



function DetailContent() {
    let card_data = [
        {
            cardImage: card_img_1,
            cardText: 'Eat Service',
            cardTitle: 'Diet, Sugar, and Inflammation',
            cardLink: 'read more',
        },
        {
            cardImage: card_img_2,
            cardText: 'Eat Service',
            cardTitle: 'I Was Critical of Anti-Vaxxers Until…',
            cardLink: 'read more',
        },
        {
            cardImage: card_img_3,
            cardText: 'Eat Service',
            cardTitle: 'How to eat well and save money',
            cardLink: 'read more',
        },
        {
            cardImage: card_img_4,
            cardText: 'Eat Service',
            cardTitle: 'Delicious Mini-Apple Pie in ',
            cardLink: 'read more',
        }
    ]

    const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);
        const handleClick = (event) => {
          setAnchorEl(event.currentTarget);
        };
        const handleClose = () => {
          setAnchorEl(null);
        };
      
    return (
        
        <>
                
            
            <Container maxWidth>
                <Box sx={{mb:'100px'}}>
                    <Navbar/>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography sx={{ fontFamily: 'Outfit', fontWeight: '400', fontSize: '14px', lineHeight: '140%', letterSpacing: '0.015em', color: '#2B817B;', marginRight: '10px' }}>EatCoast Blog  </Typography>
                    <span style={{ color: '#9EA3AE;', fontFamily: 'Outfit', fontWeight: '400', fontSize: '14px', lineHeight: '140%', letterSpacing: '0.015em', }}>Healthy Food Recommendations for ‘ Interludes’ While at Home</span>
                </Box>
            </Container>

            <center>
                <Container sx={{ marginTop: 10, }} >
                    <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '600', fontSize: { lg: '56px', md: '40px', sm: '30px', xs: '30px' }, lineHeight: '110%', color: '#1A1824;' }}>Healthy Food Recommendations for <br /> ‘ Interludes’ While at Home</Typography>
                    <Typography sx={{ fontWeight: 'Outfit', fontStyle: "normal", fontWeight: '400', fontSize: '20px', lineHeight: '140%', letterSpacing: '0.015em;', color: '#1A1824' }}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been, Lorem Ipsum is simply dummy text of the printing and typesetting industry.</Typography>
                </Container>
            </center>

            <center>
                <Container sx={{ maringTop: 10, }} maxWidth>
                    {/* <Card sx={{width:{lg:'1296px',md:'800px',sm:'1000px',xs:'800px'}}}>
                        <CardMedia
                         component='img'
                        image={poster}
                        
                        />
                    </Card> */}
                    <img id="poster" style={{ marginTop: '50px' }} src={poster} />

                    <Container className='paraContainer' maxWidt="md">
                        <Typography className="para" sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '400', fontSize: '16px', lineHeight: '160%', letterSpacing: '0.015em', textAlign: 'justify', width: '856px', marginTop: 3 }}>
                            Lorem Ipsumis simply dummy text of the printing and typesetting industry.
                            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                            when an unknown printer took a galley of type and scrambled it to make a type
                            specimen book. It has survived not only five centuries, but also the leap into
                            electronic typesetting, remaining essentially unchanged. It was popularised in
                            the 1960s with the release of Letraset sheets containing Lorem Ipsum passages,
                            and more recently with desktop publishing software like Aldus PageMaker
                            including versions of Lorem Ipsum.
                        </Typography>
                    </Container>



                </Container>
            </center>
            <Container maxWidth='md'>
                <Typography sx={{ marginTop: 5, fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: "600", fontSize: '24px', lineHeight: '150%', lineHeight: '0.01em;', color: '#1A1824;' }}>1. Salad Stop</Typography>

                <img id='poster_2' style={{ width: '856px', height: '344px', marginTop: '20px', borderRadius: '6px' }} src={poster} />
                <Typography sx={{ fontFamily: 'Outfit', fontWeight: '400', fontSize: '16px', lineHeight: '160%', letterSpacing: '0.015em', color: '#1A1824;', textAlign: 'justify' }}>
                    Lorem Ipsumis simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
                    the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                    of type and scrambled it to make a type specimen book. It has survived not only five centuries,
                    but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised
                    in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more
                    recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </Typography>

                <Typography sx={{ marginTop: 5, fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: "600", fontSize: '24px', lineHeight: '150%', lineHeight: '0.01em;', color: '#1A1824;' }}>2. Salad Stop</Typography>
                <img id='poster_2' style={{ width: '856px', height: '344px', marginTop: '20px', borderRadius: '6px' }} src={poster} />
                <Typography sx={{ fontFamily: 'Outfit', fontWeight: '400', fontSize: '16px', lineHeight: '160%', letterSpacing: '0.015em', color: '#1A1824;', textAlign: 'justify', marginTop: 2 }}>
                    Lorem Ipsumis simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
                    the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                    of type and scrambled it to make a type specimen book. It has survived not only five centuries,
                    but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised
                    in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more
                    recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </Typography>
                <Typography sx={{ fontFamily: 'Outfit', fontWeight: '400', fontSize: '16px', lineHeight: '160%', letterSpacing: '0.015em', color: '#1A1824;', textAlign: 'justify' }}>
                    Lorem Ipsumis simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
                    the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                    of type and scrambled it to make a type specimen book. It has survived not only five centuries,
                    but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised
                    in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more
                    recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </Typography>
                <Box sx={{ display: 'flex' }}>
                    <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '600', fontSize: '16px', lineHeight: '160%', letterSpacing: '0.015em' }}>Share Post:</Typography>

                    <Link href="#"><img style={{ marginLeft: '15px' }} src={Twitter} /></Link>
                    <Link href="#"><img style={{ marginLeft: '15px' }} src={Instagram} /></Link>
                    <Link href="#"><img style={{ marginLeft: '15px' }} src={Facebook} /></Link>


                </Box>


            </Container>
            <Container sx={{ marginTop: 10 }} maxWidth="xl">
                <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '600', fontSize: '32px', lineHeight: '150%', letterSpacing: '0.01em', marginLeft: '40px' }}>Related Post</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', padding: '5px' }}>
                    {card_data.map((item, key) => {
                        return(
                            <>
                            <Card key={key} sx={{ width: '300px', marginBottom: 5,
                         height:{lg:'360px'} 
                        }}>
                            <CardMedia
                                component='img'
                                width="306px"
                                height="180px"
                                borderRadius='4px'
                                image={item.cardImage}
                            />
                            <CardContent>
                                <Typography sx={{ fontSize: '16px', fontFamily: 'Outfit', fontWeight: '400', lineHeight: "160%",textDecoration: "none" ,letterSpacing: '0.015em', color: '#2B817B;' }} component="p">{item.cardText}</Typography>
                                <Typography sx={{ fontFamily: 'Outfit', fontWeight: "600", fontSize: '20px', lineHeight: '180%',textDecoration: "none", letterSpacing: '0.01em', color: "#1A1824;" }}>{item.cardTitle}</Typography>
                            </CardContent>
                            <CardActions sx={{
                                display:'flex',
                                flexDirection:'row',
                                alignItems:'end',
                                // justifyContent:'end',
                            }}>
                                <Button sx={{ fontFamily: 'Outfit', fontWeight: "400", fontSize: '16px', lineHeight: '160%', letterSpacing: '0.015em', textDecoration: "underline", color: ' #2B817B' }}>{item.cardLink}</Button>
                            </CardActions>
                        </Card>
                            </>
                        )
                        
                        
                    })}

                </Box>
            </Container>

           <Box>
                    <DiscountFooterSection/>
           </Box>
           
            <Box>
                    <Footer/>
            </Box>

        </>
    )
}

export default DetailContent